export default __webpack_public_path__ + "static/media/Bitcoin.9289e063.svg";